import { FilterCondition, SortingDirection } from "../constants/Enums";

export type EventFilter = {
  dateFrom?: Date;
  dateTo?: Date;
  gridTypeIds?: number[];
  eventLevel?: string;
  eliminated?: boolean;
  disconnections?: boolean;
  deadlinesViolated?: boolean;
  buildings: number;
  diameter?: number;
};

export type Event = {
  id: number;
  organization: object;
  address: string;
  gridType: object;
  defNature: object;
  lat: number;
  lng: number;
  dateTimeDisable: Date;
  dateTimeEnable: Date;
  overBuildings: number;
  livingBuildings: number;
  hospitalBuildings: number;
  childrenBuildings: number;
  diameter: number;
};

export type ScpResponse = {
  pageNumber: number;
  pageSize: number;
  itemCount: number;
  firstItemNumber: number;
  itemsTotal: number;
  pagesTotal: number;
  items: Event[];
};

export type NamedItem = {
  id: number;
  name: string;
  title: string;
};

export interface DictionaryItemShortDto {
  id: number;
  title: string;
}

export interface TreeNode extends DictionaryItemShortDto {
  children: TreeNode[];
}

export type InfoPaneItem = {
  gridType: NamedItem;
  totalCount: number;
  filteredCount: number;
};

export type InfoPaneResponse = {
  items: InfoPaneItem[];
  totalCount: number;
  filteredCount: number;
};

export type AnalyticsFilter = {
  dateFrom?: Date;
  dateTo?: Date;
  gridTypeId?: number;
  eliminated?: boolean;
  organizationId?: number;
  overBuildingsFrom?: number;
  overBuildingsTo?: number;
  livingBuildingsFrom?: number;
  livingBuildingsTo?: number;
  hospitalBuildingsFrom?: number;
  hospitalBuildingsTo?: number;
  childrenBuildingsFrom?: number;
  childrenBuildingsTo?: number;
  disconnectedFrom?: number;
  disconnectedTo?: number;
};

export type DispatcherEventFilter = {
  dateDisable?: Date;
  dateEnable?: Date;
  gridTypeId?: number;
  organizationId?: number;
};

export type FilterItem = {
  fieldName: string;
  value: any;
  valueTo?: any;
  condition: FilterCondition;
};

export type SortItem = {
  fieldName: string;
  direction: SortingDirection;
};

export type Search = {
  text?: string;
  fieldNames?: Array<string>;
  allTextFields?: boolean;
};

export type SearchRequest = {
  page?: number;
  count?: number;
  filterItems?: FilterItem[];
  sortItems?: SortItem[];
  search?: Search;
};

export type ConstructorRequestParams = {
  page?: number;
  count?: number;
  search?: Search;
  sortBy?: SortItem;
  filterItems?: FilterItem[];
};

export type GetClusteredRequest = {
  layerIds?: Array<number | string>;
  xMin: number;
  yMin: number;
  xMax: number;
  yMax: number;
  zoom?: number;
  proj: number;
  outOfExtent?: boolean;
};

export enum Role {
  Administrator = 1,
  Analyst = 2,
  Dispatcher = 3,
  Ces = 10,
}

export enum GeometryType {
  Point = 1,
  LineString = 2,
  Polygon = 3,
  MultiPoint = 4,
  MultiLineString = 5,
  MultiPolygon = 6,
  GeometryCollection = 7,
}

export type GeometryInfo = {
  name: string;
  color: string;
};

export type LayerDto = {
  id: number;
  name: string;
  layerTypeId: number;
};

export enum NodeType {
  Group = 0,
  Layer = 1,
}

export enum LayerType {
  Information = 1,
  Object = 2,
}

export type LayerAttributeMapItem = {
  srcAttributeName: string;
  destAttributeName: string;
};

export type OperationProgress = {
  totalObjectCount: number;
  processedObjectCount: number;
  percentage: number;
  timeEstimated: number;
  cancelled: boolean;
};

export type DeleteLayerOptions = {
  deleteObjects: boolean;
  deleteClassifier: boolean;
};

export enum SelectModeTypes {
  Multi = "multiple",
  Tags = "tags",
}

export type ISelectStatus = "error" | "warning";

export enum FileMimeTypes {
  none = -1,
  img = 0,
  doc = 1,
  xls = 2,
  xml = 3,
  pdf = 4,
}

export enum ReportProgressStatus {
  Cформирован = 0,
  "В ожидании",
  Формируется,
  "Не удалось сформировать",
}

export type ObjectAddress = {
  label: string;
  lat: number;
  lon: number;
  value: string;
};

export enum GeometryTypes {
  Polygon = "Polygon",
  MultiPolygon = "MultiPolygon",
  LineString = "LineString",
  MultiLineString = "MultiLineString",
  Point = "Point",
  GeometryCollection = "GeometryCollection",
}
